(() => {
  const hydrateHomeVideo = (video) => {
    if (!(video instanceof HTMLVideoElement) || video.dataset.esHomeVideoHydrated === 'true') return;
    if (!video.getAttribute('poster') && video.dataset.poster) video.poster = video.dataset.poster;
    let attachedSource = false;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      attachedSource = true;
    });
    video.dataset.esHomeVideoHydrated = 'true';
    if (attachedSource) video.load();
  };

  const initialiseHomeVideos = () => {
    const videos = [...document.querySelectorAll('[data-es-home-deferred-video]')]
      .filter((video) => video.dataset.esHomeVideoObserved !== 'true');
    if (!videos.length) return;
    videos.forEach((video) => { video.dataset.esHomeVideoObserved = 'true'; });
    if (!('IntersectionObserver' in window)) {
      videos.forEach((video) => {
        hydrateHomeVideo(video);
        video.play().catch(() => undefined);
      });
      return;
    }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        hydrateHomeVideo(entry.target);
        entry.target.play().catch(() => undefined);
      } else entry.target.pause();
    }), { rootMargin: '320px 0px' });
    videos.forEach((video) => observer.observe(video));
  };

  initialiseHomeVideos();
  document.addEventListener('shopify:section:load', initialiseHomeVideos);

  document.querySelectorAll('[data-cookie-preferences]').forEach((button) => {
    if (button.dataset.cookiePreferencesInitialised === 'true') return;
    button.dataset.cookiePreferencesInitialised = 'true';
    button.addEventListener('click', async () => {
      const banner = window.privacyBanner || window.Shopify?.privacyBanner;
      if (typeof banner?.showPreferences === 'function') {
        await banner.showPreferences().catch(() => undefined);
        return;
      }
      const nativePreferenceControl = document.querySelector('#shopify-pc__banner__btn-manage-prefs, [data-shopify-pc-open-preferences], #shopify-pc__prefs__header button');
      if (nativePreferenceControl instanceof HTMLElement) nativePreferenceControl.click();
      else window.location.assign('/policies/privacy-policy');
    });
  });

  document.querySelectorAll('[data-es-shell]').forEach((root) => {
    let activeDrawer = null;
    let returnFocus = null;

    const closeDrawer = () => {
      if (!activeDrawer) return;
      activeDrawer.hidden = true;
      activeDrawer = null;
      document.body.style.overflow = '';
      root.querySelectorAll('[data-drawer-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      returnFocus?.focus();
    };

    root.querySelectorAll('[data-drawer-open]').forEach((button) => {
      button.addEventListener('click', () => {
        closeDrawer();
        returnFocus = button;
        activeDrawer = root.querySelector(`[data-drawer="${button.dataset.drawerOpen}"]`);
        if (!activeDrawer) return;
        activeDrawer.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        activeDrawer.querySelector('[data-drawer-close][aria-label]')?.focus();
      });
    });

    root.querySelectorAll('[data-drawer-close]').forEach((element) => element.addEventListener('click', closeDrawer));
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });
  });
})();
